import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { formatIDR, formatDuration } from "@/lib/api";
import { SlotPicker } from "@/components/SlotPicker";

export function ScheduleCard({ t, offered }) {
  const navigate = useNavigate();
  const [serviceId, setServiceId] = useState("");
  const [duration, setDuration] = useState(0);
  const [slot, setSlot] = useState(null);

  useEffect(() => {
    if (!serviceId && offered.length) { setServiceId(offered[0].id); setDuration(offered[0].packages[0].minutes); }
  }, [offered, serviceId]);

  const service = offered.find((s) => s.id === serviceId);
  const pkg = service?.packages.find((p) => p.minutes === duration);
  const pickService = (s) => { setServiceId(s.id); setDuration(s.packages[0].minutes); setSlot(null); };

  return (
    <section id="schedule" className="ib-card scroll-mt-24" data-testid="talent-schedule-card">
      <h2 className="ib-title">Jadwal Dan Layanan Tersedia</h2>
      <div className="mt-6 flex flex-col sm:flex-row sm:items-center gap-3">
        <span className="text-base text-black w-32 shrink-0">Pilih Layanan</span>
        <div className="inline-flex flex-wrap gap-1 rounded-lg bg-[#F3F4F6] p-1" data-testid="schedule-service-tabs">
          {offered.map((s) => (
            <button key={s.id} type="button" onClick={() => pickService(s)} className={`ib-seg ${serviceId === s.id ? "active" : ""}`} data-testid={`schedule-service-${s.id}`}>{s.name}</button>
          ))}
        </div>
      </div>
      {service && (
        <div className="mt-4 flex flex-col sm:flex-row sm:items-center gap-3">
          <span className="text-base text-black w-32 shrink-0">Pilih Durasi</span>
          <div className="flex flex-wrap gap-2" data-testid="schedule-duration-chips">
            {service.packages.map((p) => (
              <button key={p.minutes} type="button" onClick={() => { setDuration(p.minutes); setSlot(null); }} className={`ib-outline ${duration === p.minutes ? "active" : ""}`} data-testid={`schedule-duration-${p.minutes}`}>
                {service.name} - {formatDuration(p.minutes)} · {formatIDR(p.price)}
              </button>
            ))}
          </div>
        </div>
      )}
      <div className="mt-6">
        {service && <SlotPicker talentId={t.id} duration={duration} value={slot} onChange={setSlot} compact theme="ib" />}
      </div>
      <div className="mt-6 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <p className="ib-muted">{pkg ? `${service.name} · ${formatDuration(pkg.minutes)} · ${formatIDR(pkg.price)}` : ""}</p>
        <div className="flex gap-2 justify-center">
          <Link to="/talent" className="ib-outline inline-flex items-center rounded-full px-6" data-testid="schedule-other-talents">Lihat talent lain</Link>
          <button disabled={!slot || !pkg} onClick={() => navigate(`/booking/${t.id}?service=${serviceId}&duration=${duration}&slot=${encodeURIComponent(slot)}`)} className="ib-btn" data-testid="schedule-continue">Lanjut Booking</button>
        </div>
      </div>
    </section>
  );
}
